import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/patients/<id>/<tab>` — the record's tab address.
 *
 * Only `clinical` is a tab today; the segment exists so an unknown or
 * unavailable tab FALLS BACK to Overview rather than a blank pane or a
 * not-found (record.md ▸ Invariants ▸ The address). The redirect lands the
 * reader on `/patients/<id>` with the Overview card drawn.
 *
 * The route carries no component: a matched child without one renders its
 * parent's — the record (`patients.$patientId.tsx`) draws the same lazy
 * screen for both addresses and reads the tab off the path, so the record
 * stays ONE chunk and the strip's height never depends on which tab asked.
 */
export const Route = createFileRoute("/_authenticated/patients/$patientId/$tab")({
  beforeLoad: ({ params }) => {
    if (params.tab !== "clinical") {
      throw redirect({
        to: "/patients/$patientId",
        params: { patientId: params.patientId },
      });
    }
  },
});
